import sounds from './soundIncludes';
const mapStateToProps = (state) => {
    return Object.assign({},state);
};

const DEFAULT_STATE = {};

const CONSTANTS = {
    mapStateToProps:mapStateToProps,
    SOUNDS:sounds,
    KEY_PRESS:['Q','W','E','A','S','D','Z','X','C'],
    DEFAULT_STATE:DEFAULT_STATE,
    ACTIONS:{
        INSTRUMENT:'INSTRUMENT'
    }
};

export default CONSTANTS;
